import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import dayjs from "dayjs";
import Datepicker from "components/Input/Datepicker/Datepicker";
import s from "./UpdateAllContent.module.scss";

const UpdateAllContent = ({ handleInput }) => {
  const { t } = useTranslation();
  const [focus, setFocus] = useState({});

  const settlementDateOnChange = (e, type) => {
    const rawDate = JSON.parse(JSON.stringify(e));
    const date = moment(rawDate).isValid()
      ? moment(rawDate).format("YYYY-MM-DD")
      : e !== null
      ? ""
      : null;
    if (type === "start") {
      handleInput(date);
    }
  };
  const settlementDateOnFocus = () => {
    setFocus({ settlementDate: true });
  };
  const settlementDateOnBlur = () => {
    setFocus({ settlementDate: false });
  };

  return (
    <div className={s.contentContainer}>
      <div>
        <Datepicker
          label={t(
            "page.finance.settlement.plan.pending.approval.update.all.function.dialog.content.1",
          )}
          mandatory
          type="start"
          noErrorMessage
          defaultValue={dayjs(new Date())}
          onchangeFn={settlementDateOnChange}
          onfocusFn={settlementDateOnFocus}
          onblurFn={settlementDateOnBlur}
          sxParams={{ datepickerFocus: focus.settlementDate }}
        />
      </div>
    </div>
  );
};

export default React.memo(UpdateAllContent);
